import { useState, useCallback } from "react";

/**
 * A hook that provides a way to toggle a boolean state on and off with two
 * separate functions (one for each state). This is useful for things like
 * toggling a loading indicator or modal. eg. openModal, closeModal.
 *
 * @param {boolean} initialState The initial state of the toggle
 * @returns {[boolean, function, function]} An array containing the current
 * state, a function to toggle the state to true, and a function to set the
 * state to false. eg. [isOpen, openModal, closeModal] = useToggle(false);
 */
export const useBinaryToggle = initialValue => {
	const [ value, setValue ] = useState(!!initialValue);

	const toggleOn = useCallback(() => setValue(true), [ setValue ]);
	const toggleOff = useCallback(() => setValue(false), [ setValue ]);

	return [
		value,
		toggleOn,
		toggleOff
	];
};